import { API_URL } from '@/modules/shared/constants/API_URL'
import { httpAuthenticationInterceptor } from '@/modules/shared/modules/http/domain/services/HTTPAuthenticationInterceptor'
import HTTPExceptionInterceptor from '@/modules/shared/modules/http/domain/services/HTTPExceptionInterceptor'
import { httpTokenInterceptor } from '@/modules/shared/modules/http/domain/services/HTTPTokenInterceptor'

import {
  PatientComorbidities,
  PatientComorbidity
} from '../../domain/models/PatientComorbidities'
import { PatientProfileMedicalRecord } from '../../domain/models/PatientProfileMedicalRecord'
import { MedicalSheetDatasource } from '../../infra/datasources/MedicalRecordDatasource'

export const medicalSheetDatasourceAdapter: MedicalSheetDatasource = {
  async getProfilePatientMedicalRecord(patientId: string) {
    const response = await HTTPExceptionInterceptor(
      await httpAuthenticationInterceptor(
        await fetch(
          `${API_URL}/v1/patients/${patientId}/data`,
          httpTokenInterceptor({
            method: 'GET'
          })
        )
      )
    )

    const json = PatientProfileMedicalRecord.parse(await response.json())
    return json
  },
  async updateProfilePatientMedicalRecord(patientId: string, data) {
    const response = await HTTPExceptionInterceptor(
      await httpAuthenticationInterceptor(
        await fetch(
          `${API_URL}/v1/patients/${patientId}/data`,
          httpTokenInterceptor({
            method: 'PUT',
            body: JSON.stringify(data),
            headers: {
              'Content-Type': 'application/json'
            }
          })
        )
      )
    )

    const json = PatientProfileMedicalRecord.parse(await response.json())
    return json
  },
  async getAllergyPatientMedicalRecord(patientId: string) {
    const response = await HTTPExceptionInterceptor(
      await httpAuthenticationInterceptor(
        await fetch(
          `${API_URL}/v1/patients/${patientId}/allergy`,
          httpTokenInterceptor({
            method: 'GET'
          })
        )
      )
    )

    const json = await response.json()
    return json
  },
  async getFullPrescriptionMedicalRecord(patientId: string) {
    const response = await HTTPExceptionInterceptor(
      await httpAuthenticationInterceptor(
        await fetch(
          `${API_URL}/v1/patients/${patientId}/full-prescriptions`,
          httpTokenInterceptor({
            method: 'GET'
          })
        )
      )
    )

    const json = await response.json()
    return json
  },
  async deleteAllergyPatientMedicalRecord(patientAllergyId: string) {
    await HTTPExceptionInterceptor(
      await httpAuthenticationInterceptor(
        await fetch(
          `${API_URL}/v1/patients/allergy/${patientAllergyId}`,
          httpTokenInterceptor({
            method: 'DELETE'
          })
        )
      )
    )
  },
  async createAllergyPatientMedicalRecord(patientId, data) {
    const response = await HTTPExceptionInterceptor(
      await httpAuthenticationInterceptor(
        await fetch(
          `${API_URL}/v1/patients/${patientId}/allergy`,
          httpTokenInterceptor({
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
              'Content-Type': 'application/json'
            }
          })
        )
      )
    )

    const json = await response.json()
    return json
  },
  async remediesHomePatientMedicalRecord(patientId: string) {
    const response = await HTTPExceptionInterceptor(
      await httpAuthenticationInterceptor(
        await fetch(
          `${API_URL}/v1/patients/${patientId}/remedies/home`,
          httpTokenInterceptor({
            method: 'GET'
          })
        )
      )
    )

    const json = await response.json()
    return json
  },
  async createRemediesHomePatientMedicalRecord(patientId, data) {
    const response = await HTTPExceptionInterceptor(
      await httpAuthenticationInterceptor(
        await fetch(
          `${API_URL}/v1/patients/${patientId}/remedies/home`,
          httpTokenInterceptor({
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
              'Content-Type': 'application/json'
            }
          })
        )
      )
    )

    const json = await response.json()
    return json
  },
  async drugAllergies(patientId: string) {
    const response = await HTTPExceptionInterceptor(
      await httpAuthenticationInterceptor(
        await fetch(
          `${API_URL}/v1/patients/${patientId}/allergies`,
          httpTokenInterceptor({
            method: 'GET'
          })
        )
      )
    )

    const json = await response.json()
    return json
  },
  async deleteDrugAllergies(allergyId: string) {
    await HTTPExceptionInterceptor(
      await httpAuthenticationInterceptor(
        await fetch(
          `${API_URL}/v1/allergies/${allergyId}`,
          httpTokenInterceptor({
            method: 'DELETE'
          })
        )
      )
    )
  },
  async deleteRemedieHome(remedyId: string) {
    await HTTPExceptionInterceptor(
      await httpAuthenticationInterceptor(
        await fetch(
          `${API_URL}/v1/remedies/${remedyId}/home`,
          httpTokenInterceptor({
            method: 'DELETE'
          })
        )
      )
    )
  },
  async getPatientComorbidities(patientId: string) {
    const response = await HTTPExceptionInterceptor(
      await httpAuthenticationInterceptor(
        await fetch(
          `${API_URL}/v1/patients/${patientId}/comorbidities`,
          httpTokenInterceptor({
            method: 'GET'
          })
        )
      )
    )

    const json = PatientComorbidities.parse(await response.json())
    return json
  },
  async createPatientComorbidity(patientId, data) {
    const response = await HTTPExceptionInterceptor(
      await httpAuthenticationInterceptor(
        await fetch(
          `${API_URL}/v1/patients/${patientId}/comorbidities`,
          httpTokenInterceptor({
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
              'Content-Type': 'application/json'
            }
          })
        )
      )
    )

    const json = PatientComorbidity.parse(await response.json())
    return json
  },
  async deletePatientComorbidity(comorbidityId: string) {
    await HTTPExceptionInterceptor(
      await httpAuthenticationInterceptor(
        await fetch(
          `${API_URL}/v1/patients/comorbidities/${comorbidityId}`,
          httpTokenInterceptor({
            method: 'DELETE'
          })
        )
      )
    )
  }
}
